/* @flow */
// https://github.com/necolas/react-native-web/issues/298#issuecomment-292776647
import { View } from "react-native";
import * as React from "react";

type Point = {
  x: number,
  y: number,
};

type Props = {
  start: Point,
  end: Point,
  locations: Array<number>,
  colors: Array<string>,
  children: any,
  style: any,
};

export default class LinearGradient extends React.PureComponent<Props> {
  render() {
    const {
      start = { x: 0, y: 0 },
      end = { x: 1, y: 1 },
      locations,
      colors,
      style,
      children,
      ...otherProps
    } = this.props;
    const vec = [end.x - start.x, -(end.y - start.y)];
    const angleRad = Math.atan(vec[1] / vec[0]);
    const angleDeg = Math.round((angleRad * 180) / Math.PI) + 180;
    const realLocations =
      locations || colors.map((color, i) => (1 / (colors.length - 1)) * i);
    const colorStrings = colors
      .map((color, i) => `${color} ${Math.round(realLocations[i] * 100)}%`)
      .join(", ");

    return (
      <View
        {...otherProps}
        style={[
          style,
          {
            backgroundImage: `linear-gradient(${angleDeg}deg, ${colorStrings})`,
          },
        ]}
      >
        {children}
      </View>
    );
  }
}
